import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";

import { AiAssistant } from "../../aiAgents.types";
import {
  AI_ASSISTANTS_QUERY_KEY,
  ApiRoutesAiAssistants
} from "../../constants/enums";

interface ListResponse {
  data: AiAssistant[];
}

export const useGetAssistants = () => {
  const { data, ...rest } = useQuery<ListResponse, ApiServiceError<ApiError>>({
    queryKey: [AI_ASSISTANTS_QUERY_KEY, "list"],
    queryFn: async () => await instance.get(ApiRoutesAiAssistants.Assistants),
    onError: toastServerError
  });

  return { assistants: data?.data ?? [], ...rest };
};
